// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1y6m{justify-content:flex-start}\n._1bahesu3{justify-content:flex-end}\n._1e0c1txw{display:flex}\n._1pfh1ejb{margin-block-start:var(--ds-space-300,24px)}", ""]);
// Exports
module.exports = exports;
